// eslint-disable-next-line import/prefer-default-export
export const parseBooleanQueryParam = (param) => {
  if (!param) {
    return false;
  }
  if (typeof param === 'boolean') {
    return param;
  }

  return param === 'true';
};
